module.exports = __webpack_public_path__ + "assets1662726319812/img/home-img.ff28be9e.jpg";